import React, { useEffect, useState } from 'react';

function Footer() {
    const [footerContent, setFooterContent] = useState('');

    useEffect(() => {
        fetch('/custom/footer.html')
            .then((response) => response.text())
            .then((data) => setFooterContent(data))
            .catch((error) => console.error('Error fetching footer content:', error));
    }, []);

    return <div className="footer" dangerouslySetInnerHTML={{ __html: footerContent }} />;
}

export default Footer;
